import { getTranslations } from './navigation-translations';
import {
    ActivityItemId,
    ActivityTypePaths,
    GetActivityTypes,
    HeaderSections
} from './navigation-types';
import { useChallengesNavigationProps } from '@containers/app/app-landing/hooks/data/use-challenges-navigation-props';
import { useNewCoursesNavigationProps } from '@containers/app/app-landing/hooks/data/use-new-courses-navigation-props';
import { CourseTypes } from '@services/gateways/combined-assign-gateway/api/combined-assign-gateway-api.types';

export const useNavigationActivityTypes = (): GetActivityTypes => {
    const {
        ACTIVITIES,
        SKILL_QUESTS,
        REVISE_5,
        ASSESSMENTS,
        TESTS
    } = getTranslations();
    const newCoursesNavigationProps = useNewCoursesNavigationProps();
    const challengesNavigationProps = useChallengesNavigationProps();

    return {
        NEW_COURSES: newCoursesNavigationProps,
        LEGACY_ACTIVITIES: {
            label: ACTIVITIES,
            id: CourseTypes.ACTIVITIES_ID,
            isHidden: false,
            isNew: false,
            isDefault: true,
            path: ActivityTypePaths.activities,
            portalId: null,
            headerSection: HeaderSections.LEARN
        },
        PSR: challengesNavigationProps,
        SKILL_QUESTS: {
            label: SKILL_QUESTS,
            id: CourseTypes.SKILL_QUESTS_ID,
            isHidden: false,
            isNew: false,
            isDefault: true,
            path: ActivityTypePaths.skillQuests,
            portalId: window._env_.SKILLS_QUEST_MODULE_ID,
            headerSection: HeaderSections.REVISE
        },
        REVISE_FIVE: {
            label: REVISE_5,
            id: 'revise-5',
            isHidden: true,
            isNew: false,
            isDefault: false,
            path: ActivityTypePaths.revise5,
            portalId: window._env_.SKILLS_QUEST_MODULE_ID,
            headerSection: null
        },
        ASSESSMENTS: {
            label: ASSESSMENTS,
            id: 4,
            isHidden: false,
            isNew: false,
            isDefault: true,
            path: ActivityTypePaths.assessments,
            portalId: window._env_.ASSESSMENTS_MODULE_ID,
            headerSection: HeaderSections.ASSESS
        },
        TESTS: {
            label: TESTS,
            id: 'tests',
            isHidden: true,
            isNew: false,
            isDefault: false,
            path: ActivityTypePaths.tests,
            portalId: null,
            headerSection: null
        }
    };
};

export const NavigationTestIds = {
    activityTypeId: (id: ActivityItemId) => `activity-type-${id}`,
    starIcon: 'navigation-star-icon'
};
